import { showError } from '@redux/actions';
import { store } from '@redux/store';
import { allowImgExt } from '@utils/constants/enums';
import { MAX_FILE_SIZE } from '@utils/constants/value';

export * from './date';

export const convertToOptions = (dict: Dict): Option[] =>
  Object.entries(dict).map(([value, label]) => ({
    value,
    label,
  }));

export const generateKey = () => {
  return crypto.randomUUID();
};

export const generateImage = (path: string) => {
  const url = `${process.env.REACT_APP_IMAGE_URL}${path}`;
  return url;
};

export const capitalizeFirstLetter = (val: string) => {
  return val.charAt(0).toUpperCase() + val.slice(1);
};

export const toLowerCaseFirstLetter = (val: string) => {
  return val.charAt(0).toLocaleLowerCase() + val.slice(1);
};

export const validateFileImage = (file: File) => {
  if (file) {
    const fileExtension = file.name.split('.').pop()?.toLowerCase() ?? '';
    if (file.size > MAX_FILE_SIZE) {
      store.dispatch(showError({ message: 'MSE00003' }));
      return false;
    } else if (!allowImgExt.includes(fileExtension)) {
      store.dispatch(showError({ message: 'common.file_extension' }));
      return false;
    }
    return true;
  }
};

export const convertToSnakeCase = (input: string) => {
  return input.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase();
};

export const formatCarNumberInput = (value: string): string => {
  let numbers = value.replace(/\D/g, '').slice(-4);
  if (numbers.length === 0) return '';
  numbers = numbers.padStart(4, '・');

  const main = numbers.slice(0, 2);
  const tail = numbers.slice(2, 4);

  return `${main}-${tail}`;
};

export const carNumberToRaw = (carNumber: string): string => {
  return carNumber.replace(/\D/g, '');
};

export const validatePhoneNumber = (value: string | number | File) => {
  const digits = String(value ?? '').replace(/\D/g, '');
  if (digits.length < 10 || digits.length > 11) {
    return 'common.require_input_number_phone';
  }
  return true;
};
